import * as React from 'react';
import { loadCSS } from 'fg-loadcss';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Icon from '@mui/material/Icon';
import MdPhone from '@mui/icons-material/Phone';
import Chip from '@mui/material/Chip';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "fg-loadcss": { loadCSS }, "@mui/material/styles": { ThemeProvider, createTheme }, "@mui/material/Stack": Stack, "@mui/material/Icon": Icon, "@mui/icons-material/Phone": MdPhone, "@mui/material/Chip": Chip } } });
export default ClientProvider;
